import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AppState {
    showDrawer: boolean;
    setShowDrawer: (show: boolean) => void;

    showExitModal: boolean;
    setShowExitModal: (show: boolean) => void;
}

// Define the store with persist middleware
export const useAppStore = create<AppState>()(
    persist(
        (set) => ({
            showDrawer:  true,
            setShowDrawer: (show: boolean) => set({ showDrawer: show }),

            showExitModal: false,
            setShowExitModal: (show: boolean) => set({ showExitModal: show }),
        }),
        { name: 'options' } // Key for persistence
    )
);
